exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media (max-width: 768px)\n{\n    .register{\n        position: relative;\n        top:110px;\n    }\n    .heading-border-bottom {\n        margin-top: 62px;\n    }\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/www/html/oneills-web-qa/src/app/login/login.component.css
// module id = ../../../../../src/app/login/login.component.css
// module chunks = main